import { Component, inject, OnInit } from '@angular/core';
import { AmplifyUser } from '@aws-amplify/ui';
import { MatDialog } from '@angular/material/dialog';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { detectEnv } from 'src/app/services/Enviroment';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from "../../../services/auth.service";
import { BoRolesCheckService } from 'src/app/components/rolesCheck/bo-roles-check.service';

@Component({
  selector: 'app-backoffice-partners',
  templateUrl: './partners.component.html',
  styles: [
    `
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
    `,
  ],
})
export class BOPartnersComponent implements OnInit {
  showSpinner = false;
  window = window;
  dialog = inject(MatDialog);
  lambda = inject(AWSLambda);
  rolesCheck = inject(BoRolesCheckService);
  protected currentEnv = detectEnv();
  user!: AmplifyUser;
  canAccess = false;

  partnersList: any[] = [];
  loadingPartners: boolean = false;
  filteredCounts: { partnersList: number } = { partnersList: 0 };
  filterPartners: any[] = [];

  constructor(
    private router: Router,
    private translate: TranslateService,
    private auth: AuthService,
  ) {}

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }

    this.user = await Auth.currentAuthenticatedUser();
    this.getPartnersList();
  }

  async getPartnersList(): Promise<void> {
    if (this.loadingPartners) return;
    this.loadingPartners = true;

    try {
      const response = await this.lambda.getLambdaFunction('lambda', '/btb/api', {
        queryStringParameters: {
          method: 'partnersList'
        }
      });

      if (response && response.partners && Array.isArray(response.partners)) {
        this.partnersList = response.partners
          .sort((a: any, b: any) => new Date(b.userCreateDate).getTime() - new Date(a.userCreateDate).getTime());

        const uniqueUserStatuses = Array.from(
          new Set(response.partners.map((partner: { userStatus: any; }) => partner.userStatus))
        ).map(status => ({
          key: status,
          value: status
        }));

        this.filterPartners = [
          { key: 'name', type: 'text', label: 'Nombre' },
          { key: 'middleName', type: 'text', label: 'Segundo Nombre' },
          { key: 'phone', type: 'text', label: 'Teléfono' },
          { key: 'email', type: 'text', label: 'Email' },
          { key: 'partnerId', type: 'text', label: 'Partner ID' },
          { key: 'userStatus', type: 'select', label: 'Estado', options: uniqueUserStatuses },
        ];
      } else {
        this.partnersList = [];
      }
    } catch (error) {
      console.error('Error loading partners list:', error);
      this.partnersList = [];
    } finally {
      this.loadingPartners = false;
    }
  }

  onPartnerClick(partner: any) {
    this.router.navigate(['/backoffice/partners', partner.username]);
  }

  onFiltersChanged(filters: any) {
    console.log('Filters changed:', filters);
  }

  onNewPartner() {
    console.log('New partner clicked');
  }

  getFullName(partner: any): string {
    const nameParts = [partner.name, partner.middleName].filter(part => part && part.trim() !== '');
    return nameParts.length > 0 ? nameParts.join(' ') : partner.email || partner.username || 'Sin nombre';
  }
}